
import {
  defineComponent, onBeforeMount, reactive,
  ref,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import storeSistema from '@/store/storeSistema';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import DisponibilidadeProdutos from '@/components/Cadastros/Produtos/ConsultaProdutos/DisponibilidadeProdutos.vue';
import ServicoControleProducao from '@/servicos/Cadastros/PCP/ServicoControleProducao';
import { IControleProducao } from '@/models/Entidades/Cadastros/PCP/IControleProducao';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import ResumoAjustesInventarioModal from './ResumoAjustesInventarioModal.vue';

export default defineComponent({
  name: 'AjusteInventario',
  components: {
    TituloPadrao,
    PreviewPdf,
    SelecionarEmpresa,
    DisponibilidadeProdutos,
    ResumoAjustesInventarioModal,
  },
  setup(props) {
    const {
      telaBase, adicionarAtalho, removerAtalho, verificaConceitoParaApresentarEmpresas, preencherEmpresasDisponiveis,
    } = useTelaBase();
    const servicoControleProducao = new ServicoControleProducao();
    servicoControleProducao.requisicaoSistema();

    const state = reactive({
      empresa: 0,
      keyDisponibilidade: 0,
      arquivosPdf: [] as IArquivoPdf[],
      produtos: [] as IDTORastreabilidade[],
      controles: [] as IControleProducao[],
      exibirResumo: false,
    });

    async function obterControles() {
      state.controles = await servicoControleProducao.obterAtivos(state.empresa);
    }

    async function aplicarAjustes() {
      state.exibirResumo = true;
    }

    async function confirmar() {
      state.keyDisponibilidade += 1;
      state.produtos = [];
    }

    onBeforeMount(async () => {
      telaBase.empresasSelecionadas = storeSistema.getters.empresasUsuarioAutenticado();
      verificaConceitoParaApresentarEmpresas();
      await preencherEmpresasDisponiveis();
      state.empresa = storeSistema.getters.codigoEmpresaOperacao();
      await obterControles();
    });

    return {
      props,
      state,
      telaBase,
      storeSistema,
      ETipoArquivo,
      adicionarAtalho,
      removerAtalho,
      aplicarAjustes,
      confirmar,
    };
  },
});
